var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useState } from "react";
export const defaultAssetResolver = (id, thumbnail) => __awaiter(void 0, void 0, void 0, function* () {
    return ({
        id,
        url: "/admin/asset/get-image-thumbnail?id=" + id + "&width=504&aspectratio=true",
        focalPoint: null,
        videoPoster: null,
        thumbnails: null
    });
});
export const defaultSnippetResolver = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch("/api/snippet/" + id);
    return yield response.text();
});
const ContentManagementContext = createContext({
    contentElementDefinitions: [],
    isEditing: true,
    activeElement: null,
    setActiveElement: () => undefined,
    resolvers: {
        document: (id) => __awaiter(void 0, void 0, void 0, function* () { return id.toString(); }),
        snippet: defaultSnippetResolver,
        asset: defaultAssetResolver
    }
});
export const ContentManagementProvider = (props) => {
    const [activeElement, setActiveElement] = useState(null);
    return (React.createElement(ContentManagementContext.Provider, { value: Object.assign(Object.assign({}, props.settings), { activeElement, setActiveElement }) }, props.children));
};
export const useContentManagement = () => {
    return useContext(ContentManagementContext);
};
export const useAssetResolver = () => {
    return useContentManagement().resolvers.asset;
};
export const useDocumentResolver = () => {
    return useContentManagement().resolvers.document;
};
export const useSnippetResolver = () => {
    return useContentManagement().resolvers.snippet;
};
